import React, { useEffect } from "react";
import { SkipToContent } from "@/components/site/SkipToContent";
import { StickyHeader } from "@/components/site/StickyHeader";
import { HeroV4 } from "@/components/site/v4/HeroV4";
import { OfferingsV4 } from "@/components/site/v4/OfferingsV4";
import { StoryV4 } from "@/components/site/v4/StoryV4";
import { ProgramsV4 } from "@/components/site/v4/ProgramsV4";
import { EventsV4 } from "@/components/site/v4/EventsV4";
import { GalleryV4 } from "@/components/site/v4/GalleryV4";
import { NewsV4 } from "@/components/site/v4/NewsV4";
import { FinalCTAV4 } from "@/components/site/v4/FinalCTAV4";
import { SiteFooter } from "@/components/site/SiteFooter";

export default function HomeV4() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <>
      <SkipToContent />
      <StickyHeader overlay />
      <main id="content" tabIndex={-1} className="outline-none">
        <HeroV4 />
        <OfferingsV4 />
        <StoryV4 />
        <ProgramsV4 />
        <EventsV4 />
        <GalleryV4 />
        <NewsV4 />
        <FinalCTAV4 />
      </main>
      <SiteFooter />
    </>
  );
}
